<template>
  <div class="operEnterprise">
    <v-publiceTit :titleObj='titleObj'></v-publiceTit>
    <div class="enterpriseBox">
      <v-enterpriseBanner></v-enterpriseBanner>
    </div>
  </div>
</template>
<script>
import publiceTit from '@/components/publiceTit'
import enterpriseBanner from '@/components/enterpriseBanner'
export default {
  data () {
    return {
      titleObj: {name: '合作企业', eng: 'COOPERATION'}
    }
  },
  components: {
    'v-publiceTit': publiceTit,
    'v-enterpriseBanner': enterpriseBanner
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/operEnterprise/index.vue